import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import CRMArrivalSourceManagement
  from "@/components/dashboard/crm-config-management/tabs/CRMArrivalSourceManagement.vue";
import CRMArrivalSubjectTable from "@/components/dashboard/crm-config-management/tabs/CRMArrivalSubjectTable.vue";
import CRMSmsOrMailManagement from "@/components/dashboard/crm-config-management/tabs/CRMSmsOrMailManagement.vue";
import CRMStatusManagement from "@/components/dashboard/crm-config-management/tabs/CRMStatusManagement.vue";
import TotalSubSectionComponent from "@/components/dashboard/lobby/sections/TotalSubSection.component.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {ArrivalSubjectCRMTableRow} from "@/models/ArrivalSubjectCRMTableRowDetails";
import {KeyValuePair} from "@payroll/optimus-common";
import Component from 'vue-class-component'
import {Action} from "vuex-class";


@Component({
  components: {
    TotalSubSectionComponent,
    CRMArrivalSourceManagement,
    CRMStatusManagement,
    CRMSmsOrMailManagement,
    CRMArrivalSubjectTable
  }
})
export default class CRMConfigManagementComponent extends AfterFetchComponent {


  @Action('getSubjectOfArrival', StoreNamespace.CUSTOMER_SERVICE) getSubjectOfArrival: any;
  @Action('getAllCRMDepartments', StoreNamespace.CUSTOMER_SERVICE) getAllCRMDepartments: any;
  @Action('getUsersBySubjectOfArrivalId', StoreNamespace.CUSTOMER_SERVICE) getUsersBySubjectOfArrivalId: any;
  @Action('getAllMangingCompanyUsers', StoreNamespace.CUSTOMER_SERVICE) getAllMangingCompanyUsers: any;
  @Action('removeUserFromDepartment', StoreNamespace.CUSTOMER_SERVICE) removeUserFromDepartment: any;
  @Action('addUserToDepartment', StoreNamespace.CUSTOMER_SERVICE) addUserToDepartment: any;
  @Action('createOrUpdateArrivalSubject', StoreNamespace.CUSTOMER_SERVICE) createOrUpdateArrivalSubject: any;
  @Action('createOrUpdateDepartmentCRM', StoreNamespace.CUSTOMER_SERVICE) createOrUpdateDepartmentCRM: any;
  @Action('getDepartmentDetails', StoreNamespace.CUSTOMER_SERVICE) getDepartmentDetails: any;




  private departmentList: any[] | undefined = []
  private selectedDepartment: any = null
  private editDepartmentDetails: any = {
    id: -1,
    description: "",
    backgroundColor: "#000000",
    activeDepartment: false
  }

  private subjectListByDepartments: any[] = []
  private departmentColor: string = "#000000";
  private activeDepartment: boolean = false;
  private usersInDepartment: KeyValuePair[] = []
  private usersNotInDepartment: KeyValuePair[] = []
  private allUsers: KeyValuePair[] = []
  private mapFromDepartmentToArrivalSubjectList: any = null
  private departmentData: any = []
  private showAddNewSubjectModal: boolean = false;
  private newArrivalSubject: ArrivalSubjectCRMTableRow = {
    id: -1,
    sla: 1,
    description: "",
    emails: [],
    activeSubject: true
  }

  private initComponentVariables() {
    this.departmentList = []
    this.subjectListByDepartments = []
    this.departmentColor = "#000000"
    this.activeDepartment = false
    this.usersInDepartment = []
    this.usersNotInDepartment = []
    this.allUsers = []
    this.mapFromDepartmentToArrivalSubjectList = null
  }

  mounted() {


    this.getAllMangingCompanyUsers({
      requestorCallback: this
    })

    this.getSubjectOfArrival({
      requestorCallback: this
    })

  }


  onSuccess(data?: any, requestName?: string, message?: string) {
    switch (requestName) {
      case 'getUsersBySubjectOfArrivalId':
        this.usersInDepartment = data.users

        const usersInDepartmentKeys = this.usersInDepartment.map((user) => user.value)
        for (let user of this.allUsers) {
          if (!usersInDepartmentKeys.includes(user.value)) {
            this.usersNotInDepartment.push(user)
          }

        }
        break;
      case 'crmConfigurationManagement/getAllMangingCompanyUsers':
        this.allUsers = data
        break;
      case 'crmConfigurationManagement/getDepartmentDetails':
        this.departmentColor = data.backgroundColor
        this.activeDepartment = data.activeDepartment
        break;
      case 'crmConfigurationManagement/createOrUpdateDepartmentCRM':
        this.initComponentVariables()
        this.getAllMangingCompanyUsers({
          requestorCallback: this
        })

        this.getSubjectOfArrival({
          requestorCallback: this
        })

        this.onHideModal();
        this.showSuccessAction(this.$t(`CRMConfigManagement.departmentChangeSuccessMessage`) as string)
        break;
      case 'crmConfigurationManagement/createOrUpdateArrivalSubject':
        this.departmentData = data
        this.onHideModal()
        this.showSuccessAction(this.$t(`CRMConfigManagement.subjectAddedSuccessMessage`) as string)
        break;

      case 'getSubjectOfArrival':
        this.mapFromDepartmentToArrivalSubjectList = data.mapFromDepartmentToSubjectList
        this.getAllCRMDepartments({
          requestorCallback: this
        })
        break;

      case 'crmConfigurationManagement/getAllCRMDepartments':
        this.departmentList = data

        if (this.departmentList) {
          if (this.departmentList.length > 0) {
            this.selectedDepartment = this.departmentList[0]
            this.subjectListByDepartments = this.mapFromDepartmentToArrivalSubjectList[this.selectedDepartment.value]
          }
        }
        break;
      case 'statusesTypes':
        break;

      case 'crmConfigurationManagement/removeUserFromDepartment':
        const removedUser = data.user
        this.usersNotInDepartment.push(removedUser)
        this.usersInDepartment = this.usersInDepartment.filter((userIn) => userIn.value != removedUser.value)
        this.showSuccessAction(`המשתמש/ת ${removedUser.description} הוסר בהצלחה מ- ${this.selectedDepartment.description}`)
        break

      case 'crmConfigurationManagement/addUserToDepartment':
        const addedUser = data.user
        this.usersInDepartment.push(addedUser)
        this.usersNotInDepartment = this.usersNotInDepartment.filter((userNotIn) => userNotIn.value != addedUser.value)
        this.showSuccessAction(`המשתמש/ת ${addedUser.description} נוסף בהצלחה ל- ${this.selectedDepartment.description}`)
        break

    }
  }

  onShowAddNewSubjectModal() {
    this.showAddNewSubjectModal = true;

  }

  onSelectDepartment(selectedValue: any) {

    this.departmentData = []
    this.subjectListByDepartments = []

    this.selectedDepartment = selectedValue
    setTimeout(() => {
      this.subjectListByDepartments = this.mapFromDepartmentToArrivalSubjectList[this.selectedDepartment.value]

      this.usersInDepartment = [];
      this.usersNotInDepartment = []
      this.getUsersBySubjectOfArrivalId({
        requestorCallback: this,
        pathVariable: this.subjectListByDepartments[0].value
      })


      this.getDepartmentDetails({
        requestorCallback: this,
        pathVariable: this.selectedDepartment.value
      })

    }, 100);
  }

  onAddUserToDepartment(user: KeyValuePair) {
    const body = {
      department: this.selectedDepartment,
      user: user
    }

    this.addUserToDepartment({
      requestBody: body,
      requestorCallback: this
    })
  }

  onRemoveUserFromDepartment(user: KeyValuePair) {
    const body = {
      department: this.selectedDepartment,
      user: user
    }

    this.removeUserFromDepartment({
      requestBody: body,
      requestorCallback: this
    })
  }


  private showSuccessAction(message: string) {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: message,
      icon: 'checkCircle',
      secondsToDisappear: 3
    })
  }

  private onHideModal() {
    this.newArrivalSubject = {
      id: -1,
      sla: 1,
      description: "",
      emails: [],
      activeSubject: true
    }
    this.showAddNewSubjectModal = false
    this.showEditDepartmentDetailsModal = false
    this.showAddNewDepartmentDetailsModal = false
  }

  private onSaveNewSubject() {
    const request = {
      ...this.newArrivalSubject,
      departmentId: this.selectedDepartment.value
    }

    this.createOrUpdateArrivalSubject({
      requestorCallback: this,
      requestBody: request
    })
  }

  private updateNewDepartmentColor(newColor: string) {
    let backgroundColor = newColor
    if (newColor !== this.departmentColor) {
      this.createOrUpdateDepartmentCRM({
        requestorCallback: this,
        requestBody: {
          backgroundColor,
          id: this.selectedDepartment.value
        }
      });
    }
  }

  private updateDepartmentDetails() {

    this.createOrUpdateDepartmentCRM({
      requestorCallback: this,
      requestBody: {
        ...this.editDepartmentDetails
      }
    });
  }

  private showEditDepartmentDetailsModal: boolean = false;
  private showAddNewDepartmentDetailsModal: boolean = false;
  private onShowEditDepartmentDetailsModal() {
    this.editDepartmentDetails.backgroundColor = this.departmentColor
    this.editDepartmentDetails.id = this.selectedDepartment.value
    this.editDepartmentDetails.activeDepartment = this.activeDepartment
    this.showEditDepartmentDetailsModal = true
  }

  private onShowAddNewDepartmentDetailsModal() {
    this.editDepartmentDetails = {
      id: -1,
      description: "",
      backgroundColor: "#000000"
    }
    this.showAddNewDepartmentDetailsModal = true
  }

  updateEditDepartmentBackgroundColor(selectedColor: any) {
    this.editDepartmentDetails.backgroundColor = selectedColor
  }
}
